<form role="form" class="layout-grid" #passwordForm="ngForm" (ngSubmit)="onSubmit_changePassword(passwordForm)" aria-labelledby="aria_page_header">
  <mat-form-field>
    <mat-label>Current Password</mat-label>
    <input matInput
      id="main-content-focus"
      type="password"
      autocomplete="current-password"
      [(ngModel)]="passwordChange.oldPassword"
      #currentPasswordModel="ngModel"
      name="Current Password"
      required>
      @if (currentPasswordModel.invalid) {
        <mat-error>{{validationService.getFieldErrorMessage(currentPasswordModel.name, currentPasswordModel)}}</mat-error>
      }
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic">
      <mat-label>New Password</mat-label>
      <input matInput
        type="password"
        autocomplete="new-password"
        [(ngModel)]="passwordChange.newPassword"
        #newPasswordModel="ngModel"
        name="Password"
        required
        [pattern]="passwordService.passwordPattern">
        <mat-hint>
          <app-password-caption [password]="passwordChange.newPassword" [error]="passwordError">
          </app-password-caption>
        </mat-hint>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Confirm Password</mat-label>
        <input matInput
          type="password"
          autocomplete="new-password"
          [(ngModel)]="passwordChange.confirmPassword"
          #confirmPasswordModel="ngModel"
          name="Confirm Password"
          required
          [validateMatchField]="passwordChange.newPassword">
          @if (confirmPasswordModel.invalid) {
            <mat-error>{{validationService.getFieldErrorMessage(confirmPasswordModel.name, confirmPasswordModel, validationService.fieldErrors[confirmPasswordModel.name])}}</mat-error>
          }
        </mat-form-field>

        <button type="submit" matButton="filled">
          Change Password
        </button>
      </form>